
// export async function getAddinToken(code,callback) {
//   const myHeaders = new Headers();
// myHeaders.append("Content-Type", "application/json");

// const raw = JSON.stringify({
// "code": `${code}`
// });

// const requestOptions:any = {
//   method: "POST",
//   headers: myHeaders,
//   body: raw,
//   redirect: "follow"
// };

// fetch("https://staging-api.portant.dev/microsoft/addin/token/", requestOptions)
//   .then((response) => response.text())
//   .then((result) => {
//     localStorage.setItem("addin_token", result);
//     callback(result,null);
//   })
//   .catch((error) => {
//     console.error(error)
//         callback(null,error);
//   });
// }


export async function getAddinToken(code: string, callback: any) {
  try {
    const response = await fetch(
      "https://api.portant.co/microsoft/addin/token/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ code }),
      }
    );

    // 🔥 NEW: Handle 404 specifically
    if (response.status === 404) {
      callback(null, { type: "NO_ACCOUNT" });
      return;
    }

    if (!response.ok) {
      callback(null, { type: "GENERIC_ERROR" });
      return;
    }

    const token = await response.text();
    localStorage.setItem("addin_token", token);
    callback(token, null);

  } catch (error) {
    console.error(error);
    callback(null, { type: "NETWORK_ERROR" });
  }
}
